import type React from 'react';

import { Toast, styled } from '@creditas-ui/react';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import {
  type FeedbackType,
  removeFeedback,
} from '../../../store/reducers/feedback';

const Container = styled.div`
  position: fixed;
  right: 0;
  top: 40px;
  margin: 0 27px;
  display: grid;
  grid-gap: 20px;
  z-index: 1500;
  width: 400px;
`;

const StyledToast = styled(Toast)`
  max-width: none;
  width: 100%;
`;

export const Feedback: React.FC = () => {
  const dispatch = useDispatch();
  const { items } = useSelector((state: RootState) => state.feedbackStore);

  if (isEmpty(items)) {
    return <></>;
  }

  const getSymbol = (type: FeedbackType) => {
    switch (type) {
      case 'error':
        return '⚠️';
      case 'success':
        return '😉';
      default:
        return '😐';
    }
  };

  return (
    <Container data-testid="feedback-container">
      {items.map((message) => (
        <StyledToast
          emoji={{
            label: message.type,
            symbol: getSymbol(message.type),
          }}
          key={message.id}
          closeable={true}
          onClose={() => dispatch(removeFeedback(message.id))}
          variant="dark"
          data-testid="toast-error"
        >
          {message.text}
        </StyledToast>
      ))}
    </Container>
  );
};
